const about_CN_Locale = {
    'about.about': '关于我们',
    'about.honors': '荣誉资质',
    'about.culture': '企业文化',
    'about.aboutRayshape': '关于度影',
    'about.rayshape': '深圳度影医疗科技有限公司',
    'about.rayshapeIntroduce': '度影医疗成立于2019年，总部位于深圳，是一家持续专注于全栈式智能超声产品研发的国家级高新技术企业。团队在智能超声领域深耕近20年，在疾病智能辅助筛查、超声影像智能质控、一站式智能标注、动态高维的超声AI算法、AI模型通用部署框架等多方面均已实现关键突破及产品化，已全面覆盖妇产、心脏、浅表和腹部等多个临床方向。',
    'about.foundingYear': '成立时间',
    'about.YearsOf': '智能超声领域',
    'about.Expertise': '',
    'about.fieId': '',
    'about.numberOf': '智能超声应用授权数',
    'about.Authorized': '',
    'about.Applications': '',
    'about.corePatents': '超声领域核心专利和软著',
    'about.software': '',
    'about.TheUItrasound': '',
    'about.DevelopmentHistory': '发展历程',
    'about.PartnerHospitals': '合作医院',
    'about.scrollListArrTitle1': '中国人民解放军总医院',
    'about.scrollListArrTitle2': '苏州市立医院(南京医科大学附属苏州医院)',
    'about.scrollListArrTitle3': '华中科技大学同济医学院附属同济医院',
    'about.scrollListArrTitle4': '湖北省妇幼保健院',
    'about.scrollListArrTitle5': '上海交通大学医学院附属瑞金医院',
    'about.scrollListArrTitle6': '山东大学齐鲁医院',
    'about.scrollListArrTitle7': '中国医科大学附属盛京医院',
    'about.scrollListArrTitle8': '西北妇女儿童医院',
    'about.scrollListArrTitle9': '四川省妇幼保健院',
    'about.scrollListArrTitle10': '重庆医科大学附属儿童医院',
    'about.scrollListArrTitle11': '中南大学湘雅三院',
    'about.scrollListArrTitle12': '湖南省妇幼保健院',
    'about.scrollListArrTitle13': '中山大学孙逸仙纪念医院',
    'about.scrollListArrTitle15': '深圳市人民医院',
    'about.scrollListArrTitle16': '深圳市罗湖区人民医院',
    'about.scrollListArrTitle17': '广西壮族自治区人民医院',
    'about.scrollListArrTitle18': '福建省妇幼保健院',
    'about.scrollListArrTitle19': '浙江省人民医院',
    'about.scrollListArrTitle20': '南昌大学第二附属医院',
    'about.scrollListArrTitle21': '佛山市第一人民医院',
    'about.scrollListArrTitle22': '云南省妇幼保健院',
    'about.scrollListArrTitle23': '新疆自治区人民医院',
    'about.contactUs': '联系我们',
    'about.Name': '您的称呼',
    'about.phoneNumber': '您的手机号',
    'about.OrganizationName': '单位名称',
    'about.Suggestions': '写下您的需求和建议',
    'about.SubmitMessage': '提交留言',
    'about.honorTime1': '2021年',
    'about.honorContent1': "获得国家高新技术企业证书",
    'about.honorTime2': '2022年',
    'about.honorContent2': "获得ISO13485：2016 认证证书",
    'about.honorTime3': '2023年',
    'about.honorContent3': "获得ISO27001 信息安全管理体系认证证书",
    'about.honorTime4': '2023年',
    'about.honorContent4': "开展国家重点研发计划智能产前超声多中心临床研究",
    'about.honorTime5': '2021年',
    'about.honorContent5': "首张盆底超声影像处理软件NMPA注册证",
    'about.honorTime6': '2022年',
    'about.honorContent6': "首张婴幼儿髋关节智能超声辅助筛查NMPA注册证",
    'about.honorTime7': '2023年',
    'about.honorContent7': "首张产前超声影像处理软件NMPA注册证",
    'about.honorTime8': '2024年',
    'about.honorContent8': "乳腺超声影像处理软件NMPA注册证",
    'about.honorTime9': '2022年',
    'about.honorContent9': "国际智能医学影像顶级期刊发文总量排名第1，核心期刊文章谷歌被引量达15000",
    'about.honorTime10': '2023年',
    'about.honorContent10': "超声领域核心专利和软著超40项",
    'about.culturalTitle1': "客户至上",
    'about.culturalContent1': '我们坚持客户至上的理念，不断优化产品和服务，为用户提供更好的使用感受',
    'about.culturalTitle2': "创新专注",
    'about.culturalContent2': '我们将创新专注作为企业发展的核心战略，致力于打造领先的医疗科技产品和解决方案',
    'about.culturalTitle3': "勇于担当",
    'about.culturalContent3': '我们以勇于担当为使命，不畏挑战，勇于探索创新，为用户提供高品质的医疗产品',
    'about.culturalTitle4': "快乐平等",
    'about.culturalContent4': '打造一个开放、包容的度影大家庭，与员工携手共进，让每一个人都有良好的工作环境与广阔的发展空间',
    'about.culturalImgTitle1': '让“超人”更超能',
    'about.culturalImgContent1': '全新的产品理念与产品布局，聚焦成像优化，扫查导航，标准采集，量化质控，辅助诊断等关键环节。通过人工智能有效提高超声筛查效率，减少诊断差异化，全面拓展超声临床应用。',
    'about.culturalImgTitle2': '使命',
    'about.culturalImgContent2': '用AI技术造福人类健康',
    'about.culturalImgTitle3': '愿景',
    'about.culturalImgContent3_1': '提高超声诊断的标准化与普及率',
    'about.culturalImgContent3_2': '致力成为智能超声的全球领导者',
    'about.hospitalsName1': '中国-深圳',
    'about.hospitalsName2': '中国-北京',
    'about.hospitalsName3': '中国-上海',
    'about.hospitalsName4': '中国-广州',
    'about.hospitalsName5': '中国-成都',

}
export default about_CN_Locale
